import {intRandom} from './_randNum';

export function issueImages() {
  const img = document.querySelectorAll('.js-issue-image-container');
  const ww = window.document.documentElement.clientWidth;

  for (let i = 0; i < img.length; i++) {
    const el = img[i];
    const y = intRandom(-0.2*ww,0.05*ww);
    const x = intRandom(-0.2*ww,0.2*ww);
    const w = intRandom(5,15);
    el.style.transform = `translate(${x}px,${y}px)`;
    el.setAttribute('data-x', x);
    el.setAttribute('data-y', y);
    el.style.width = `${w}%`;
    if(el.classList.contains('is-others')) {
      const yy = intRandom(0,80);
      const xx = intRandom(-110,100);
      el.style.top = `${yy}%`;
      el.style.left = `${xx}%`;
    }
    el.classList.add('is-active');
  }
}